export const formContainer = 'w-full'
export const titleDiv = "text-left mb-3"
export const title = "text-2xl font-bold mb-4"
export const subtitle = "text-sm font-normal"
